const initState = {
  pizzaMoneyAthletes: [],
  lastDocument: "",
  hasMoreDocument: true,
  activePizzaMoneyAthletes: [],
  activeLastDocument: "",
  activeHasMoreDocument: true,
  donors: [],
  fanBadges: [],
};
const pizzaMoneyReducer = (state = initState, action) => {
  switch (action.type) {
    case "PIZZA_MONEY_ATHLETES_ACTIVE":
      return {
        ...state,
        activePizzaMoneyAthletes: action.payload.data,
        activeLastDocument: action.payload.lastDocument,
        activeHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "MORE_PIZZA_MONEY_ATHLETES_ACTIVE":
      return {
        ...state,
        activePizzaMoneyAthletes: [
          ...state.activePizzaMoneyAthletes,
          ...action.payload.data,
        ],
        activeLastDocument: action.payload.lastDocument,
        activeHasMoreDocument: action.payload.hasMoreDocument,
      };
    case "PIZZA_MONEY_ATHLETES":
      return {
        ...state,
        pizzaMoneyAthletes: action.payload.data,
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "MORE_PIZZA_MONEY_ATHLETES":
      return {
        ...state,
        pizzaMoneyAthletes: [
          ...state.pizzaMoneyAthletes,
          ...action.payload.data,
        ],
        lastDocument: action.payload.lastDocument,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "FAN_DONORS":
      return {
        ...state,
        donors: action.payload,
      };
    case "FAN_BADGES":
      return {
        ...state,
        fanBadges: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default pizzaMoneyReducer;
